import type { OptionsType, MicroAppConfigType, lifeCyclesType, plugins } from '@micro-app/types'
import preFetch from './prefetch'
import { EventCenterForBaseApp } from './interact'

class MicroApp extends EventCenterForBaseApp implements MicroAppConfigType {
  version = '__VERSION__'
  shadowDOM?: boolean
  destory?: boolean
  inline?: boolean
  disableScopecss?: boolean
  disableSandbox?: boolean
  macro?: boolean
  lifeCycles?: lifeCyclesType
  plugins?: plugins
  fetch?: (url: string, config: Record<string, any>) => Promise<string>
  preFetch = preFetch
  use (options: OptionsType) {
    if (toString.call(options) === '[object Object]') {
      this.shadowDOM = options.shadowDOM
      this.destory = options.destory
      this.inline = options.inline
      this.disableScopecss = options.disableScopecss
      this.disableSandbox = options.disableSandbox
      this.macro = options.macro

      if (toString.call(options.lifeCycles) === '[object Object]') {
        this.lifeCycles = options.lifeCycles
      }

      if (typeof options.fetch === 'function') {
        this.fetch = options.fetch
      }

      // 多次定义的插件可以合并
      if (toString.call(options.plugins) === '[object Object]') {
        // 初始时直接赋值
        if (!this.plugins) {
          this.plugins = options.plugins
        } else { // 已经初始化过则进行插件合并
          if (toString.call(options.plugins!.global) === '[object Array]') {
            if (toString.call(this.plugins.global) !== '[object Array]') {
              this.plugins.global = options.plugins!.global
            } else {
              // @ts-ignore
              this.plugins.global = this.plugins.global.concat(options.plugins.global)
            }
          }
          const modules = options.plugins!.modules
          // 外部传入的modules存在
          if (toString.call(modules) === '[object Object]') {
            if (toString.call(this.plugins.modules) !== '[object Object]') {
              this.plugins.modules = modules
            } else {
              for (const key in modules) {
                if (toString.call(modules[key]) === '[object Array]') {
                  if (toString.call(this.plugins.modules![key]) !== '[object Array]') {
                    this.plugins.modules![key] = modules[key]
                  } else {
                    this.plugins.modules![key] = this.plugins.modules![key].concat(modules[key])
                  }
                }
              }
            }
          }
        }
      }

      if (options.preFetchApps) {
        preFetch(options.preFetchApps)
      }
    }
  }
}

export default new MicroApp()
